export default __webpack_public_path__ + "static/media/logoTmov.8f899020.svg";